export const EntityType = Object.freeze({
    TRAIL: 'trails',
    POINT: 'points'
});



// WEBPACK FOOTER //
// src/constants/openexplore.js